/* eslint-disable prettier/prettier */
import GoogleIcon from '@mui/icons-material/Google'
import React from 'react'
import Cookies from 'js-cookie'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ThemeSwitch from '../../components/ThemeSwitch'
import { AUTH_COOKIE } from '../../helpers/Constants'
import { isSessionRejected } from '../../helpers/session'
import { useThemeMode } from '../../theme/ThemeModeProvider'
import { TEXT } from '../../theme/tokens'
import { endpoints } from '../../services/axios/endpoints'
import BhanzuLogoWhite from './../../assets/images/bhanzu-logo-white.webp'
import BhanzuLogoDeepBlue from './../../assets/images/bhanzu-logo-black.svg'
import {
    BhanzuLogo,
    LoginButtonContainer,
    LoginContainer,
    StyledGoogleButton,
} from './LoginStyles'

const Login = () => {
    const onLoginClick = () => (window.location.href = endpoints.login())
    // Here because the API rejected the session (helpers/session.js).
    const sessionEnded = isSessionRejected(Cookies.get(AUTH_COOKIE))
    const { mode } = useThemeMode()
    return (
        <LoginContainer>
            <Box sx={{ position: 'absolute', top: 12, right: 16 }}>
                <ThemeSwitch />
            </Box>
            <LoginButtonContainer>
                <BhanzuLogo
                    src={mode === 'dark' ? BhanzuLogoWhite : BhanzuLogoDeepBlue}
                    alt="Bhanzu"
                />
                <StyledGoogleButton
                    size="large"
                    variant="contained"
                    startIcon={<GoogleIcon />}
                    onClick={onLoginClick}
                >
                    Sign in with Google
                </StyledGoogleButton>
                {sessionEnded && (
                    <Typography
                        role="status"
                        variant="body2"
                        sx={{
                            color: TEXT.secondary,
                            textAlign: 'center',
                            mt: 1.5,
                        }}
                    >
                        Your session ended. Sign in again to continue.
                    </Typography>
                )}
            </LoginButtonContainer>
        </LoginContainer>
    )
}

export default Login
